// Renders the maintenance window if maintenance mode
// is currently true in the application's state.
// @flow
import React from 'react';
import { connect } from 'react-redux';
import type { MaintenanceState } from '../../state/reducer/maintenance/reducer';

type Props = {
    maintenance: MaintenanceState,
    children: any
};

const MaintenanceGate = ({ maintenance, children }: Props) => {
    if (!maintenance.enabled) {
        return <div>{children}</div>;
    }

    const maintenaceStyle = (
        <style
            dangerouslySetInnerHTML={{
                __html: `
            #root{
                padding-top: 0;
            }
                iframe {
                    width: 100vw;
                    height: 100vh;
                    }
    `
            }}
        />
    );

    return (
        <div>
            {maintenaceStyle}
            <iframe
                frameBorder={0}
                style={{ flex: 1 }}
                src={maintenance.pageURL}
                title="Our systems are under maintenance, check back later."
            />
        </div>
    );
};

export default connect((state: any, ownProps: any) => {
    return {
        ...ownProps,
        maintenance: state.maintenance
    };
})(MaintenanceGate);
